import { publicUrlFor } from "../../globals/constants";
import { NavLink } from "react-router-dom";

function InnerPageBanner({_data}) {
    return (
        <>
            <div  style={{textAlign:"center",justifyContent:"center",alignContent:"center",alignItems:"center",alignSelf:"center",paddingTop:"90px", height:"60px" }}>
                <div className="overlay-main site-bg-white opacity-01" />
                <div className="container">
                    <div className="wt-bnr-inr-entry">
                      
                        {/* BREADCRUMB ROW */}
                        {/* <div>
                            <ul className="wt-breadcrumb breadcrumb-style-2">
                                <li><NavLink to="/index">Home</NavLink></li>
                                <li>{_data.crumb}</li>
                            </ul>
                        </div> */}
                        {/* BREADCRUMB ROW END */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default InnerPageBanner;